<template>
  <div class="container container-small" id="app">
    <div class="row">
      <div class="col-md-12 titlerow">
        <a href="/"><img src="./assets/selogo.svg" class="logo"/></a>
      </div>
    </div>
    <div id="nav" class="mt-1 mb-1">
      <router-link to="/">Home</router-link> |
      <router-link to="/articles">Articles</router-link> |
      <router-link to="/contact">Contact</router-link>
    </div>
    <router-view/>
    <div class="row">
      <div class="col-md-12">
        <small class="disclaimer">
          <strong>Legal Disclaimer</strong>
          <p>The scientificedibles.com calculator only provides dosage estimates, and is not professional medical/scientific advice. scientificedibles.com does not endorse nor is it responsible for the accuracy of the information presented. 
            This website is for users who are over the age of 21. This website features content about cannabis which may be a scheduled substance in certain areas. All content on this site is for educational and informational purposes only. Any use of the information 
            on this site is at your own risk, and scientificedibles.com is not liable for any loss, damages (to you, or others) or criminal liability you have incurred or may incur in the future.</p>
        </small>
        <small><p style="text-align:center"><router-link to="/privacy">Privacy Policy</router-link></p></small>
      </div>
    </div>
    <b-modal ref="agemodal" no-close-on-backdrop no-close-on-esc hide-footer hide-header-close centered title="Are you over the age of 21, and is cannabis legal in your jurisdiction?" class="text-center">
      <b-button variant="success" block @click="ageVerifyPass">Yes</b-button>
      <b-button variant="danger" block @click="ageVerifyFail">No</b-button>
    </b-modal>
  </div>
</template>

<script>
export default {
  mounted(){
    if(localStorage.getItem('age-verify') == null){
      this.$refs.agemodal.show()
    }
  },
  methods: {
    ageVerifyPass(){
      this.$refs.agemodal.hide()
      localStorage.setItem('age-verify',true)
    },
    ageVerifyFail(){
      window.history.back();
    }
  }
  
}
</script>

<style>
#nav a {
  font-weight: bold;
  color: #333;
}

#nav {
  text-align: center;
}
#nav a.router-link-exact-active {
  color: #32A852;
}

.titlerow {
  text-align: center;
}

.container-small { 
  max-width: 800px !important;
}

.disclaimer {
  color:dimgray
}

.logo {
  width: 50%;
}
</style>
